import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

/**
 * Bandeau persistant affiché sur toutes les pages du dashboard prestataire
 * tant que la complétude est < 60 %. Refetch à chaque navigation pour
 * refléter en direct les mises à jour du profil.
 */
export default function IncompleteProfileBanner() {
  const { user } = useAuth();
  const location = useLocation();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user || user.role !== "prestataire") return;
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/prestataires/me/completion");
        if (mounted) setData(data);
      } catch (_) { /* silent */ }
    })();
    return () => { mounted = false; };
  }, [user, location.pathname]);

  if (!user || user.role !== "prestataire") return null;
  if (!data || data.percent >= 60) return null;

  const visible = data.visible_in_search;
  return (
    <div
      className={`border-l-4 ${visible ? "border-[#E8710A] bg-[#FFF7ED]" : "border-[#B7443A] bg-[#FEF2F2]"} p-3 flex items-center gap-3 flex-wrap`}
      data-testid="incomplete-profile-banner"
    >
      <AlertTriangle size={18} className={visible ? "text-[#E8710A]" : "text-[#B7443A]"} />
      <div className="flex-1 min-w-[240px] text-sm text-[#1F2933]">
        {visible
          ? <>Votre profil est complété à <strong>{data.percent} %</strong>. Continuez pour apparaître en premier dans les recherches.</>
          : <>Votre profil n'apparaît <strong>pas encore</strong> dans les résultats — complétez-le à 40 % minimum pour être visible.</>}
      </div>
      <Link
        to="/app/dashboard"
        className="btn-primary"
        data-testid="banner-cta-complete-profile"
      >
        Compléter mon profil
      </Link>
    </div>
  );
}
